import { observer } from 'mobx-react-lite';
import { IContentSearchResult } from '../../../domain/types/IContentSearchResult';
import { getUrlForPageId } from '../../../../../utils/getUrlForLink';
import { useCommonData } from '../../../../../common-data/useCommonData';
import InformationIcon from '../../../../../assets/icons/info.svg';
import {
	StyledRouterLinkContainer,
	IconWrap,
	Information,
	Title,
	Separator,
	Snippet,
} from './SearchResultItem.styles';

interface IProps {
	result: IContentSearchResult;
}

export const SearchResultItem = observer(({ result }: IProps) => {
	const { pathToPageIdMap } = useCommonData();
	const title = result.snippet.title.value;
	const snippet = result.snippet.bodyString?.value;
	const href = getUrlForPageId(result.pageId, pathToPageIdMap);

	return (
		<StyledRouterLinkContainer href={href}>
			<IconWrap>
				<InformationIcon role="presentation" />
			</IconWrap>
			<Information>
				<Title
					dangerouslySetInnerHTML={{
						// eslint-disable-next-line @typescript-eslint/naming-convention
						__html: title,
					}}
				/>

				{snippet && (
					<>
						<Separator />
						<Snippet
							dangerouslySetInnerHTML={{
								// eslint-disable-next-line @typescript-eslint/naming-convention
								__html: snippet,
							}}
						/>
					</>
				)}
			</Information>
		</StyledRouterLinkContainer>
	);
});
